import { Operator, TargetMetric } from '@app/shared/models/contracts/enums/shared-enums';
import { enumKeyByValue } from '../enum-key-by-value';
import { l } from '@locale/setupI18n';
import {
  calculatedMultipleValueFormatterProps,
  numberValueFormatter,
  toPercentageUsingFormatter,
} from '@app/shared/formatters';

export const getOperator = (operator: keyof typeof Operator) => {
  switch (operator) {
    case enumKeyByValue(Operator, Operator.GreaterThan):
      return '>';
    case enumKeyByValue(Operator, Operator.LessThan):
      return '<';
    case enumKeyByValue(Operator, Operator.GreaterThanOrEqual):
      return '≥=';
    case enumKeyByValue(Operator, Operator.LessThanOrEqual):
      return '≤=';
    default:
      return operator;
  }
};

export const getMetric = (metric: string) => {
  switch (metric) {
    case enumKeyByValue(TargetMetric, TargetMetric.InstitutionalIRR):
      return l('_IRR');
    case enumKeyByValue(TargetMetric, TargetMetric.InstitutionalMoM):
      return l('_MoM');
    default:
      return metric;
  }
};

export const formatValueForTargetMetric = (metric: string, value: number) =>
  metric === enumKeyByValue(TargetMetric, TargetMetric.InstitutionalIRR)
    ? toPercentageUsingFormatter(value)
    : numberValueFormatter({
        value: value,
        ...calculatedMultipleValueFormatterProps,
      });

export const noEscapeValueInterpolationOption = {
  escapeValue: false,
};
